<template>
	<div class="single-banner">
		<div class="mobile-mode">
			<a v-if="config.mobile_image_url" :href="config.url"><img :src="config.mobile_image_url" class="d-block w-100" alt="slide"></a>
			<a v-else :href="config.url"><img :src="config.image_url" class="d-block w-100" alt="slide"></a>
		</div>
		<div class="desktop-mode">
			<a :href="config.url"><img :src="config.image_url" class="d-block w-100" alt="slide"></a>
		</div>
	</div>
</template>
<script>
export default {
	name: 'Banner',
	props: {
		config: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
		};
	},
};
</script>
<style lang="scss" scoped>
	.single-banner {
		img {
			border-radius: 5px;
		}
	}
	.desktop-mode {
		display: block;
	}

	@media only screen and (max-width: 767px) {
		.desktop-mode {
			display: none;
		}
	}
	@media only screen and (min-width: 768px) {
		.mobile-mode {
			display: none;
		}
	}
</style>
